// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609091247/js/" + chunkId + "." + {"44":"cf77c294","225":"deb47b19","481":"95e01742","486":"e327ea68","770":"8fe11816"}[chunkId] + ".0.4653917430969351.chunk.js";
};